import React, { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Login } from "@gisce/oficina-virtual-components";
import { RootState } from "@/store";
import useCredentials from "./Authentication/hooks/useCredentials";
import { useSettingsContext } from "./Settings/hooks/useSettingsContext";
import ServerElementsWithoutActions from "./ServerElements/components/ServerElementsWithoutActions";


const LoginView: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const Settings = useSettingsContext();
  const { loginCredentials } = useCredentials();
  const { 
    isAuthenticating,
    status,
    statusCode
  } = useSelector((state: RootState) => state.auth);
  const loginType = useSelector((state: RootState) => state.auth.type);

  const handleSignUp = () => {
    navigate(t('common:url.activate'));
  };

  const handleReset = () => {
    navigate(t('common:url.resetPassword'));
  };

  const handleLogin = (user: string, password: string) => {
    loginCredentials({user, password});
  };

  const getErrorMessage = () => {
    switch(statusCode) {
      case 401:
        return t('common:text.login_view_message_error_login');
      case 403:
        return t('common:text.login_view_message_error_login');
      
      default: 
        return t('common:text.login_view_message_error_login');
    }
  }

  return (
    <>
      <Login
      alertProps={
        loginType === "USER_AND_PASSWORD" &&
        status === "error" ? 
        {
          severity: "error", 
          label: getErrorMessage()
        } 
        : undefined
      }
      signUp={Settings?.features?.signup}
      onLogin={handleLogin}
      onSignUp={handleSignUp}
      onReset={handleReset}
      loading={isAuthenticating}
    />
      <ServerElementsWithoutActions groupName="Login" />
    </>
  );
};

export default LoginView;